import React from "react";
import "./AnimatedBackgroundSVG.css"

const AnimatedBackgroundSVG = () => {
  return (
    <svg
    id="erM4gQfHnvb1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 800 600"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    className="animated-svg" // Apply the class
//     style={{
//       width: "100%",
//       height: "100%",
//       position:"absolute",
//       top:"0px",
// marginTop:"0px",
//       overflow:"visible"

//     }}
  >
    <style>
      {`
        #erM4gQfHnvb2_tr {
          animation: erM4gQfHnvb2_tr__tr 10000ms linear infinite normal forwards;
        }
        @keyframes erM4gQfHnvb2_tr__tr {
          0% {
            transform: translate(391px, 296px) rotate(0deg);
          }
          50% {
            transform: translate(391px, 296px) rotate(80deg);
          }
          100% {
            transform: translate(391px, 296px) rotate(0deg);
          }
        }
        #erM4gQfHnvb7_ts {
          animation: erM4gQfHnvb7_ts__ts 10000ms linear infinite normal forwards;
        }
        @keyframes erM4gQfHnvb7_ts__ts {
          0% {
            transform: translate(121px, 260px) scale(1, 1);
          }
          50% {
            transform: translate(121px, 260px) scale(2, 2);
          }
          100% {
            transform: translate(121px, 260px) scale(1, 1);
          }
        }
      `}
    </style>
    <defs>
      <filter
        id="erM4gQfHnvb3-filter"
        x="-150%"
        y="-150%"
        width="400%"
        height="400%"
      >
        <feGaussianBlur
          id="erM4gQfHnvb3-filter-blur-0"
          stdDeviation="75,75"
          result="result"
        />
      </filter>
    </defs>
    <g
      id="erM4gQfHnvb2_tr"
      transform="translate(391,296) rotate(0)"
    >
      <circle
        r="273.5"
        transform="translate(0,0)"
        fill="none"
        stroke="#000"
        strokeWidth="3"
        strokeMiterlimit="3.8637"
        strokeDasharray="3,30"
      />
    </g>
    <g transform="translate(11-88)" filter="url(#erM4gQfHnvb3-filter)">
      <circle
        r="234"
        transform="translate(380 384)"
        fill="#fcc"
        fillOpacity="0.2"
      />
    </g>
    <path
      d="M617,229c0,6.627-5.373,12-12,12s-12-5.373-12-12s5.373-12,12-12s12,5.373,12,12Z"
      transform="translate(11-88)"
      fill="#74b9ff"
    />
    <circle
      r="7"
      transform="translate(571 501)"
      fill="#74b9ff"
    />
    <g
      id="erM4gQfHnvb7_ts"
      transform="translate(121,260) scale(1,1)"
    >
      <circle
        r="12"
        transform="translate(0,0)"
        fill="#74b9ff"
      />
    </g>
  </svg>


  );
};

export default AnimatedBackgroundSVG;
